var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { apiCreateUserPageViewActionAction } from '../../actions/AnalyticsActions';
import { propChildren, propFunc, propNumber, propStr, } from '../../helpers/custom-prop-types';
import { logError } from '../../helpers/logger';
/**
 * @deprecated 以降はTS化した src/hooks/action/pageView/usePageViewAction.ts を利用してください。
 */
class PageViewActionHocBase extends Component {
    constructor() {
        super(...arguments);
        this.apiCreateUserPageView = (action, subAction, actionId) => __awaiter(this, void 0, void 0, function* () {
            const { action: actionProp, actionId: actionIdProp, apiCreateUserPageViewAction, pageViewId, subAction: subActionProp, } = this.props;
            if (!pageViewId) {
                return;
            }
            try {
                yield apiCreateUserPageViewAction(pageViewId, actionProp || action, subActionProp || subAction, actionIdProp || actionId);
            }
            catch (e) {
                logError(e);
            }
        });
    }
    render() {
        const _a = this.props, { children } = _a, otherProp = __rest(_a, ["children"]);
        return cloneElement(children, Object.assign(Object.assign({}, otherProp), { apiCreateUserPageView: this.apiCreateUserPageView }));
    }
}
PageViewActionHocBase.propTypes = {
    action: propStr(),
    actionId: propNumber(),
    apiCreateUserPageViewAction: propFunc().isRequired,
    children: propChildren().isRequired,
    pageViewId: propNumber(),
    subAction: propStr(),
};
PageViewActionHocBase.defaultProps = {
    action: undefined,
    actionId: undefined,
    pageViewId: undefined,
    subAction: undefined,
};
const mapStateToProps = ({ analytics }) => ({
    pageViewId: analytics.pageViewId,
});
const mapDispatchToProps = (dispatch) => ({
    apiCreateUserPageViewAction: (pageViewId, action, subAction, actionId) => new Promise((resolve, reject) => {
        dispatch(apiCreateUserPageViewActionAction({
            action,
            actionId,
            subAction,
        }, pageViewId, { reject, resolve }));
    }),
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
const EnhancePageViewActionHocBase = enhance(PageViewActionHocBase);
export default (ChildComponent) => (props) => (_jsx(EnhancePageViewActionHocBase, Object.assign({}, props, { children: _jsx(ChildComponent, Object.assign({}, props)) })));
